import type { IconData } from '@stacksjs/iconify-core'

export const brightnessUpF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M10 14.858a4 4 0 1 1 0-8a4 4 0 0 1 0 8m6-5h3a1 1 0 0 1 0 2h-3a1 1 0 0 1 0-2m-6 6a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0v-3a1 1 0 0 1 1-1m0-15a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0v-3a1 1 0 0 1 1-1m-9 9h3a1 1 0 1 1 0 2H1a1 1 0 0 1 0-2m13.95 4.535l2.121 2.122a1 1 0 0 1-1.414 1.414l-2.121-2.121a1 1 0 0 1 1.414-1.415m-8.486 0a1 1 0 0 1 0 1.415l-2.12 2.12a1 1 0 1 1-1.415-1.413l2.121-2.122a1 1 0 0 1 1.414 0M17.071 3.787a1 1 0 0 1 0 1.414L14.95 7.322a1 1 0 0 1-1.414-1.414l2.12-2.121a1 1 0 0 1 1.415 0m-12.728 0l2.121 2.121A1 1 0 1 1 5.05 7.322L2.93 5.201a1 1 0 0 1 1.414-1.414z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default brightnessUpF
